import { useFeatureFlag } from "../utils/FeatureFlagHelper";

interface SettledFeatureFlagResult {
  enabled: boolean;
  isLoading: boolean;
}

/**
 * Hook that waits for the feature flag API call to complete before
 * considering the flag value "ready" for routing decisions.
 *
 * @param flagKey - The feature flag key
 * @param defaultValue - The default value (only used if API fails)
 */
export function useSettledFeatureFlag(
  flagKey: string,
  defaultValue: boolean = false,
): SettledFeatureFlagResult {
  const result = useFeatureFlag(flagKey, defaultValue);
  const { enabled, isFetching, isPlaceholderData, isSuccess, isError } = result;

  const isLoading =
    (isFetching && isPlaceholderData) || (!isSuccess && !isError);

  return {
    enabled: enabled ?? defaultValue,
    isLoading,
  };
}
